import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import PropTypes from 'prop-types'
import Button from '../../sitewide/Button'

import css from './PreviewDestination.css'

class PreviewDestination extends Component {
  constructor(props) {
    super(props)

    this.state = {
      destination: '',
    }
  }

  handleInput = (e) => {
    this.setState({
      destination: e.target.value,
    })
  }

  render() {
    const { destination } = this.state
    const { isEmail, sendPreview, toggle } = this.props
    return (
      <div className={css.modal}>
        <div
          className={css.close}
          onClick={toggle}
        />
        <span>{`Send this to yourself at this ${isEmail ? 'email' : 'number'}`}</span>
        <TextField
          hintText={isEmail ? 'john@aol.com' : '555 555 5555'}
          onChange={this.handleInput}
          underlineFocusStyle={{ borderColor: '#0084ff' }}
        />
        <Button onClick={() => sendPreview(destination)}>
          SEND PREVIEW
        </Button>
      </div>
    )
  }
}

PreviewDestination.propTypes = {
  isEmail: PropTypes.bool.isRequired,
  sendPreview: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default PreviewDestination



// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/PreviewDestination.js